<template>
	<CreationWizardStepWrapper>
		<template #header>
			<SlackNativeSettingsHeader v-bind="$props" v-on="$listeners" />
		</template>
		<div class="display-flex height-100 flex-wrap">
			<div class="flex-col-12">
				<FeatureNameInputField v-model="name" />
				<h3 class="reg extra-details">You will be able to run this feature from Slack by using the slash command "/ply [Feature Name]"</h3>
			</div>

			<div class="flex-1 flex-center--end pt-6">
				<PrimaryButton @click="create" :disabled="creationIsDisabled" :loading="loading">Create</PrimaryButton>
			</div>
		</div>
	</CreationWizardStepWrapper>
</template>

<script>
import { FlowType, WorkflowAccessType } from '@ply-io/ply-front-shared-utilities';

import FeatureNameInputField from './inputs/FeatureNameInputField.vue';
import WizardStepMixin from '../../WizardStepMixin';
import SlackNativeSettingsHeader from '../SlackNativeSettings/SlackNativeSettingsHeader.vue';
import { createAndSelectWorkflow } from '@/store/modules/selectedWorkflow/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
import { SLACK_PLACEMENT_ID } from '@/utils/workflow-tool-service.const';
export default {
	name: 'CreateSlackFeature',
	mixins: [WizardStepMixin],
	components: { SlackNativeSettingsHeader, FeatureNameInputField },
	computed: {
		creationIsDisabled() {
			return isNullOrUndefinedOrEmpty(this.name);
		},
	},
	methods: {
		...mapActionsShorthand({ createAndSelectWorkflow }),
		async create() {
			const toolPreferences = { main_placement: SLACK_PLACEMENT_ID, slack_enabled: true };
			const workflow = {
				workflow_title: this.name,
				flow_type: FlowType.Tool,
				access_type: WorkflowAccessType.SharedUsersOnly,
				project: this.selectedProjectId,
				tool_preferences: toolPreferences,
			};
			this.loading = true;
			try {
				// This will auto redirect to the new created flow!
				this.closeWizard();
				const newWorkflow = await this.createAndSelectWorkflow({ workflow });
				this.workflowCreated(newWorkflow);
			} catch (err) {
				this.$toast.error('Error occurred while creating new flow');
				throw err;
			} finally {
				this.loading = false;
			}
		},
	},
	data() {
		return { name: '', loading: false };
	},
};
</script>

<style scoped lang="scss">
@import '@/components/CreationWizard/assets/creation-wizard-vars.scss';
.middle-section {
	h3 {
		color: $secondary-content-title-font-color;
	}
}
</style>
